import { NavLink, useParams } from "react-router-dom";
import data from "@/pages/resources/case.json";
import Footer from "../landing/layout/Footer";
import Header from "../landing/layout/Header";

interface Stat {
    percentage: string;
    heading: string;
}

interface Quote {
    text: string;
    name: string;
    designation: string;
    image: string;
}

interface Content {
    tops: string;
    image: string;
    bottom: string;
}

interface RightSection {
    image: string;
    description: string;
    industry: string;
    merchant: string;
    size: string;
    location: string;
}

interface Case {
    id: string;
    image: string;
    heading: string;
    stats: Stat[];
    quote: Quote;
    content: Content;
    right: RightSection;
}

const CardPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const cases = (data as Case[]).find((item) => item.id === id);

    if (!cases) {
        return <div className="tw-text-center tw-text-red-500">Case Study not found</div>;
    }

    return (
        <>
        <Header />
            <div className="tw-px-5 tw-w-full tw-text-white">
                <div
                    style={{ backgroundImage: `url(${cases?.image})` }}
                    className="tw-w-full tw-h-[90vh] tw-bg-center tw-bg-cover tw-p-2 md:tw-p-10 tw-flex tw-items-end tw-rounded-xl"

                >
                    <div className="tw-bg-[#151516] tw-p-5 lg:tw-py-10 md:tw-w-3/6 tw-items-start tw-flex tw-flex-col lg:tw-px-10 tw-rounded-xl">
                        <h1 className="lg:tw-text-4xl tw-font-semibold">{cases?.heading}</h1>
                        <a
                            href="#mainContent"
                            className="lg:tw-mt-5 tw-mt-2 lg:tw-px-6 tw-p-2 lg:tw-py-3 tw-rounded-lg tw-font-semibold tw-text-[#151516] tw-bg-[#00c5fb]"
                        >
                            Read Story
                        </a>
                    </div>
                </div>

                <div className="tw-grid tw-mt-5 md:tw-grid-cols-2  tw-gap-5">
                    {cases?.stats?.map((item, key) => (
                        <div
                            key={key}
                            className="tw-p-10 tw-text-[#484848] tw-bg-[#0c0c0c] tw-text-center tw-rounded-xl"
                        >
                            <h1 className="lg:tw-text-9xl tw-text-5xl tw-mb-2 tw-font-bold">{item?.percentage}</h1>
                            <span className="tw-text-xl tw-font-bold">{item?.heading}</span>
                        </div>
                    ))}
                </div>

                <div id="mainContent" className="tw-flex tw-justify-center">
                    <div className="tw-mt-20 tw-grid md:tw-grid-cols-3 tw-w-[80vw] tw-gap-10 lg:tw-mx-20">
                        {/* Left Content */}
                        <div className="tw-col-span-2 lg:tw-mr-47">
                            <img src="/case/Vector.svg" alt="Double Quote" />
                            <h3 className="md:tw-text-3xl tw-mt-5 tw-font-bold">{cases?.quote?.text}</h3>
                            <div className="tw-grid tw-grid-cols-3 tw-text-lg tw-items-center  md:tw-w-1/2 tw-mb-50 tw-mt-5">
                                <img
                                    src={cases?.quote?.image}
                                    className="tw-w-[80%] tw-rounded-full tw-objec-cover"
                                    alt="user"
                                />
                                <div className="tw-col-span-2">
                                    <h3 className="tw-text-xl tw-font-semibold">{cases?.quote?.name}</h3>
                                    <span className="tw-font-light">{cases?.quote?.designation}</span>
                                </div>
                            </div>

                            <div id="article-content" className="caseContent lg:tw-text-xl text">
                                <div dangerouslySetInnerHTML={{ __html: cases?.content?.tops }} />
                                <img src={cases?.content?.image} className="tw-my-10" alt="" />
                                <div dangerouslySetInnerHTML={{ __html: cases?.content?.bottom }} />
                            </div>
                        </div>

                        {/* Right Sidebar */}
                        <div className="tw-sticky tw-w-full md:tw-block tw-hidden tw-h-fit tw-top-10">
                            <div className="tw-flex tw-flex-col tw-bg-[#151515] tw-mb-5 tw-rounded-xl tw-text-sm tw-p-2 lg:tw-p-10 tw-gap-4">
                                <img
                                    src={cases?.right?.image}
                                    className="tw-w-2/3 tw-max-h-50 tw-object-cover"
                                    alt="branding"
                                />
                                <span>{cases?.right?.description}</span>
                                <div>
                                    <h4>INDUSTRY</h4>
                                    <span>{cases?.right?.industry}</span>
                                </div>
                                <div>
                                    <h4>MERCHANT TYPE</h4>
                                    <span>{cases?.right?.merchant}</span>
                                </div>
                                <div>
                                    <h4>COMPANY SIZE</h4>
                                    <span>{cases?.right?.size}</span>
                                </div>
                                <div>
                                    <h4>LOCATION</h4>
                                    <span>{cases?.right?.location}</span>
                                </div>
                            </div>
                            <div className="tw-bg-[#00C5FB] tw-text-black tw-font-semibold tw-rounded-xl tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-10 tw-py-4">
                                <span className="tw-text-lg">
                                    Interested in learning how Protega can support your business?
                                </span>
                                <NavLink to={'/schedule-demo'} className="tw-bg-white tw-p-3 tw-text-center tw-w-full tw-text-xl tw-rounded-xl">
                                    Schedule a Demo
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default CardPage;
